import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { styled } from "styled-components";
import { Carousel, Tooltip } from "antd";
import dayjs from "dayjs";
import { keyframes } from "styled-components";

export async function getReview() {
  const response = await axios.get("/homepageReview?vetIdx=14"); // vetIdx 수정
  return response.data;
}

function Review() {
  const [windowWidth, setWindowWidth] = useState();

  const [dataList, setDataList] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(3); // 캐러셀 초기 슬라이더 갯수 설정

  const [animate, setAnimate] = useState(false);
  const componentRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      let review_data = [
        {
            "idx": 78,
            "vetIdx": 14,
            "nickname": "억이금이네",
            "imgUrl": null,
            "content": "이사로 인해 병원을 옮겨야되는 상황이였고...우리아이가 뇌수막염이여서...24시 동물병원을 찾고있었는데 정말 잘 선택한것 같아요!\n의사선생님도 간호사분들도 친절하시고\n시설도 깨끗하고 제일 중요한건!! 의사선생님의\n자세한 설명에 감사함을 느꼈습니다.\n우리아가 힘내자❤️",
            "regDate": "2024-07-21"
        },
        {
            "idx": 85,
            "vetIdx": 14,
            "nickname": "kim****",
            "imgUrl": null,
            "content": "우리아들 애기때부터 슬개골안좋았던거알았는데 최근에3기되어서 잽싸게 수술시켰습니다. 여러분 저는 이병원에 한두해다닌사람이아닙니다ㅋ 강아지를 사랑하신다면 그리고혹시 아이상태가 많이 심각한상태다싶으시다면 반드시 추천드립니다.특히 황원장님진료추천이요~ 우리애기키우기전에 앞전아이도 아프₩카에선 당장 오늘밤이 고비라고 겁주며 진료포기하셔서 찾아갔왔던곳이 여기였어요.그아이가 비록 시한부였지만1년반을넘게 제옆을지켜주다갔던일도있네요~ 저는알바도아니고 그냥 이병원다니는 애기 보호자에요 우리애기완전오다리였는데ㅜ요번에 황원장님께서 수술너무잘해주시고 간호사분들도 너무잘케어해주셔서 경과도좋고ㅜㅎ비포사진찾으면 다시더첨부해야겠어요ㅋ아무튼 성심성의껏 잘진료해주시는 의료진분들 항상너무감사하고요..저는 평생주치의찾아서든든합니당ㅎ늘감자❤️",
            "regDate": "2023-06-05"
        },
        {
            "idx": 77,
            "vetIdx": 14,
            "nickname": "alya",
            "imgUrl": null,
            "content": "15살 노견인데 뇌 문제로 대발작이나서 응급으로 방문했습니다. 정말 이대로 갑자기 떠나는줄 알았는데 멀뚱멀뚱 다시 눈떠서 제품으로 돌아왔습니다!\n입원해 있는동안 사진도 오전 오후 매일 보내주시고 전화 응대도 즉각즉각 너무 잘 받아주셔서 안심하고 아기 치료했습니다! 이제 통원 치료 열심히 받으면서 더욱 회복해 나가는 아기 모습이 기대되요! 무지개다리 문턱에서 제품으로 다시 돌려보내주셔서 너무 감사합니다!",
            "regDate": "2024-07-22"
        },
        {
            "idx": 84,
            "vetIdx": 14,
            "nickname": "piggy99",
            "imgUrl": null,
            "content": "다른 병원에서 스케일링 맡겼다가 기도가 파열되서 전신피하기종과 기흉이 생겼다고 했어요 모르고 지났으면 생명이 위급했고 전 병원에서 스카이동물병원으로 바로 인계해줘서 호흡기치료받으면서 수술하기로 했었는데 너무 안쪽이 찢어져서 수술각도가 안나와서 다시 닫았어요 시간지나면서 자연적으로 아물기를 바라자고 하셔서 걱정많았는데 우리 어르신이 다행히 이겨냈어요 만약 지켜보다가 기도가 안붙으면 가슴뼈 열어야된대서 너무 무서웠는데 다행이었어요\n의사선생님과 간호사선생님들이 입원해있는 긴 시간동안 매일 밤낮으로 고생해주시고 아침 저녁으로 사진도 보내주셔서 안심할수있었어요! 간호해주신 선생님들 우리 뚜비 예뻐해주셔서 감사드리고 뚜비 상태와 경과 상세히 알려주시고 수술해주신 황야원선생님도 감사합니다!\n덕분에 지금은 건강해요!",
            "regDate": "2023-07-01"
        },
        {
            "idx": 83,
            "vetIdx": 14,
            "nickname": "또또33",
            "imgUrl": null,
            "content": "12월초에 강아지 발작으로 응급실 방문\nmri 검사하니 뇌수막염이라서 지금까지\n다니고 있습니다.\n매일 약을먹어야 하는데\n한달치 처방가능해서 좋아요\n야간 당직 여선생님은 솔직히 불친절,퉁명스럽고 별로예요. 검사 권유도 많이 하는편이구요\n저희 강아지 담당 원장님은 친절하시고\n너무 좋으세요. 전화로 문의해도 친절하게 받아주시고요. 강아지 짧으면 6개월 시한부 판정 받았는데\n약먹고 건강해져서 뛰어다닙니다!\n아직 약먹어야 살수있지만 그래도 너무 감사합니다\n직원분들도 친절하시고 강아지 예뻐하고 좋아요\n저는 집이 서구청인데도 늘 부평 스카이로 다닙니다\n그만큼 시설좋고 원장님은 친절하고 실력좋고 과잉진료없어요.",
            "regDate": "2023-07-22"
        },
        {
            "idx": 87,
            "vetIdx": 14,
            "nickname": "도솔미파",
            "imgUrl": null,
            "content": "병원 옮기려고 오늘 초진 방문했어요. 워낙 큰병원이고 진료 받는 환견들이 많아서 안좋은 평도 그만큼 많았던건지... 저는 완전 만족했어요 전에 다니던 병원이 얼마나 대충 일하고 돈돼는것만 치료하려고 했는지 느끼게 해줬어요..\n직원분들도 전부 다 친절하시구 대기가 초진이라 너무 오래 걸리긴했는데 예약제도 가능하고 의사쌤도 설명 정말 상세히 해주시고 너무 맘에 들었어요 !!",
            "regDate": "2021-12-24"
        },
        {
            "idx": 82,
            "vetIdx": 14,
            "nickname": "초코제리",
            "imgUrl": null,
            "content": "셋째 치아 스케일링&발치를 했어요. 마취를 해야 해서 수술날짜 잡고나서부터 너무 노심초사였는데…치과 의사선생님께서 잘 치료해주셨어요. 덕분에 크림이는 밥도 잘 먹고 컨디션도 좋아요. 이제 치아 통증이 없어서 그런 것 같아요. 감사드려요!",
            "regDate": "2023-08-07"
        },
        {
            "idx": 76,
            "vetIdx": 14,
            "nickname": "jdh****",
            "imgUrl": null,
            "content": "울아기귀염증생겨서방문~\n원장님완전짱친절하세요~\n슬개골도여기서했는데~\n밤새샌님들이함께계셔서넘조아요~\n깔끔하고환경이타병원과비교할수없음요\n~거리는멀지만믿고다닐수있는곳이라정말조아요~감사하죠♡",
            "regDate": "2024-07-25"
        },
        {
            "idx": 86,
            "vetIdx": 14,
            "nickname": "zz4092",
            "imgUrl": null,
            "content": "평이 안 좋은게 몇개 있어서 평소에 안 가려했었던 병원중 하나였는데 아이가 아파서 오늘 집 앞 동네 동물병원에 갔더니 큰 병원으로 가라고 해서 지푸라기 잡는 심정으로 급하게 예약하고 갔어용 ㅜ 근데 원장님께서 정말 필요한 검사들만 해주시려 하시고 저희 고양이한테 딸아이 다루듯이 해주셔서 데려갔던 동생이 좋았다고 하네요! 감사합니다 👍",
            "regDate": "2022-09-08"
        },
        {
            "idx": 79,
            "vetIdx": 14,
            "nickname": "cej****",
            "imgUrl": null,
            "content": "에디슨을 앓고있던 우리 민트가\n비만세포종으로 첫 방문시 다른병원에선 절단밖에 답이없다했을때 하늘이무너졌었는데 황원장님과 인연이맺어져 수술잘 마치고 예후 관찰하면서 최근 PLE 의심으로 테이퍼링하고있어요,,원장님 조용조용 보호자의 궁금증에 충분한 설명과 이해를 잘 시켜주셔서 넘 좋아요\n병원오면 넓은 개방감에 정말 놀라워요\n앞으로도 쭈욱 다닐꺼에요 ㅎ 감사합니다",
            "regDate": "2024-07-15"
        },
        {
            "idx": 81,
            "vetIdx": 14,
            "nickname": "초코제리",
            "imgUrl": null,
            "content": "첫째 항문낭염 때문에 진료받고 있는데 잘생기고💜 처치도 잘해주시는 원장님 덕분에 아픈 곳 나았어요! 음…원래 집 근처 다니는 병원이 있는데 약을 거기서 처방받으면 토해서 응급 질병 아니지만 여기로 왔어요. 선생님이 처방해주시는 약은 구토 없이 잘 먹거든요. 항상 친절하고 자세하게 설명해주시고 고양이 진료해주셔서 감사합니다.",
            "regDate": "2023-08-11"
        },
        {
            "idx": 80,
            "vetIdx": 14,
            "nickname": "nkt****",
            "imgUrl": null,
            "content": "반려견 병원은 큰병원이 좋아요.\n피검사도 빠르고 시설도 깨끗하고 인천에서 MRI찰영할수있는 곳이라 더 믿음이 가는병원입니다. 울 별이. 5일입원하고 2주째 다니고있지만 가장 중요한건 모든 쌤들이 엄청 친절하셔서 더 믿고 울 별이를 맡길수있었습니다.",
            "regDate": "2024-07-11"
        }
      ];
      setDataList(review_data);
      // try {
      //   // API 호출
      //   const res = await getReview();
      //   // 데이터 받아오면 상태 업데이트
      //   if (res.result === "ok") {
      //     setDataList(res.data);
      //     console.log('review');
      //     console.log(res.data);
      //   } else console.log(res.result);
      // } catch (error) {
      //   console.error("Error fetching review data:", error);
      // }
    };

    fetchData(); // 함수 호출
  }, []); // 빈 배열은 컴포넌트가 마운트될 때 한 번만 실행

  useEffect(() => {
    const handleScroll = () => {
      // 예시: 화면의 중간에 도달했을 때 애니메이션을 실행하려면
      // const midScreen = window.innerHeight * 5.5;
      const componentTop = componentRef.current.getBoundingClientRect().top;

      // console.log('innerHeight : ', window.innerHeight);
      // console.log('scrollY : ', window.scrollY);
      // console.log('midScreen : ', midScreen);
      if (componentTop < window.innerHeight) {
        setAnimate(true);
      }
      // else {
      //   setAnimate(false);
      // }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      // 컴포넌트 언마운트 시 이벤트 리스너 제거
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setWindowWidth(window.innerWidth);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);

      // 화면 크기에 따라 slidesToShow 값을 동적으로 변경
      if (window.innerWidth < 576) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 768) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    // 컴포넌트 마운트 시 초기 값 설정
    handleResize();

    // 창 크기가 변경될 때마다 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };

  const maskedNickname = (nickname) =>
    nickname.substring(0, 2) + "*".repeat(nickname.length - 2);

  return (
    <>
      <Container>
        <TextWrapper ref={componentRef}>
          <div className={animate ? "animate" : ""}>
            <p style={{ margin: 0 }}>Review</p>
            <h2 style={{ margin: 0, marginBottom: "16px" }}>
              <strong>리/얼/후/기</strong>
            </h2>
          </div>
        </TextWrapper>
        <CarouselContainer>
          <StyledCarousel
            slidesToShow={slidesToShow}
            autoplay={true}
            autoplaySpeed={5000}
            dots={false}
            // dotPosition="bottom"
          >
            {dataList.map((item, index) => (
              <div key={item.idx}>
                <div
                  style={{
                    margin: "5px 20px",
                    boxSizing: "border-box",
                  }}
                >
                  {slidesToShow === 2 ? (
                    <Tooltip
                      title={item.content}
                      overlayStyle={{
                        letterSpacing: "1px",
                        lineHeight: "1.5",
                        maxWidth: "400px",
                      }}
                      overlayInnerStyle={{
                        // backgroundColor: "whitesmoke",
                        // color: "#000",
                        padding: "10px 20px",
                      }}
                    >
                      <div
                        style={{
                          minHeight: "300px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          textAlign: "center",
                          padding: "20px",
                          borderRadius: "20px",
                          boxShadow: "0 4px 8px rgb(0,0,0,0.2)",
                          // border: "1px solid #ccc",
                          // backgroundColor: "#e2edf6",
                        }}
                      >
                        <div>
                          <p className="name">
                            {maskedNickname(item.nickname)}님의 리뷰
                          </p>
                          <p className="content">
                            {dayjs(item.regDate).format("YYYY.MM")}
                          </p>
                          <p className="content">
                            {windowWidth < 576 || windowWidth > 768
                              ? item.content
                              : truncateText(item.content, 100)}
                          </p>
                        </div>
                      </div>
                    </Tooltip>
                  ) : (
                    <div
                      style={{
                        minHeight: "300px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        textAlign: "center",
                        padding: "20px",
                        borderRadius: "20px",
                        boxShadow: "0 4px 8px rgb(0,0,0,0.2)",
                        // border: "1px solid #ccc",
                        // backgroundColor: "#e2edf6",
                      }}
                    >
                      <div>
                        <p className="name">
                          {maskedNickname(item.nickname)}님의 리뷰
                        </p>
                        <p className="content">
                          {dayjs(item.regDate).format("YYYY.MM")}
                        </p>
                        <p className="content">
                          {slidesToShow === 2
                            ? truncateText(item.content, 100)
                            : item.content}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </StyledCarousel>
        </CarouselContainer>
      </Container>
    </>
  );
}

const Container = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%; /* 가로 폭 100%로 설정 */
  padding: 5rem 1rem;
  /* margin: 50px 42px 60px 42px; */
  /* background-color: whitesmoke; */
  & .name {
    font-size: 1.2rem;
    font-weight: 700;
  }
`;

const CarouselContainer = styled.div`
  width: 100%;
`;

const StyledCarousel = styled(Carousel)`
  .slick-dots {
    padding: 0; /* 기존 패딩 초기화 */
    list-style: none; /* 리스트 스타일 제거 */

    li {
      margin-right: 8px; /* 도트 간 여백 조절 */
      button {
        margin-top: 40px; /* 기존 마진 초기화 */
        width: 8px; /* 도트 크기 조절 */
        height: 8px;
        border-radius: 50%; /* 도트를 원 모양으로 만들기 */
      }
    }
  }
`;

const TitleWrapper = styled.div`
  width: 80%;
  height: fit-content;
  @media screen and (max-width: 690px) {
    padding-bottom: 2rem;
  }
  padding-bottom: 4rem;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      color: #000048;
      font-size: 3rem;
      margin: 0;
    }
    p {
      color: #000048;
      margin: 5px;
    }
  }
`;

const slideDown = keyframes`
    from {
        transform: translate(0, -50%);
        opacity: 0;
    }
    to {
        transform: translate(0,0);
        opacity: 1;
    }
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  color: #403631;

  @media screen and (max-width: 500px) {
    justify-content: center;
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      font-size: 2.5rem;
      font-weight: normal;
      @media screen and (max-width: 690px) {
        font-size: 2rem;
      }
    }
    p {
      font-weight: bold;
      font-size: 0.9rem;
      opacity: 0.6;
    }
  }

  .animate {
    animation: ${slideDown} 4s ease;
  }
`;

export default Review;
